import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const Link = dynamic(() => import("@/common/UI/Link"));
const Logo = dynamic(() => import("@/components/common/Logo"));

import { getHeaderMenuSlug } from "@/utils/functions";

function Footer(props) {
  const { siteConfig, labelsList } = props;

  const { route, isPreview } = useRouter();

  const [showData, setShowData] = useState(false);
  const [saveTheChildrenTitle, setSaveTheChildrenTitle] = useState("");
  const [saveTheChildrenSubTitle, setSaveTheChildrenSubTitle] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fax, setFax] = useState("");
  const [contactDetail, setContactDetail] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(true);

  const { sediPageData } = useSelector((state) => {
    return {
      sediPageData: state?.sediPage?.sediDetailsData?.premise,
    };
  });

  useEffect(() => {
    if (siteConfig?.logoFooter) {
      setTimeout(() => {
        setShowData(true);
      }, 500);
      if (siteConfig?.saveTheChildren) {
        let index = siteConfig?.saveTheChildren?.indexOf("\n");
        setSaveTheChildrenTitle(
          siteConfig?.saveTheChildren.substring(0, index)
        );
        setSaveTheChildrenSubTitle(
          siteConfig?.saveTheChildren.substring(index)
        );
      }

      if (siteConfig?.contactInfo) {
        let contactInfo = siteConfig?.contactInfo;
        let list = contactInfo?.split("\n");
        let newList = [];
        list?.filter((item) => {
          if (item?.indexOf("info") > -1) {
            setEmail(item);
          } else if (item?.indexOf("fax") > -1) {
            setFax(item);
          } else if (item?.indexOf("tel") > -1) {
            setPhone(item);
          } else {
            newList?.push(item);
          }
        });
        setContactDetail(newList?.join("\n"));
      }
    }
  }, [siteConfig]);

  //overlapping banner
  useEffect(() => {
    const body = document.body;
    if (isPreview) {
      body.classList.add("hideIndex");
    } else {
      body.classList.remove("hideIndex");
    }
  }, [isPreview]);

  const HoverLink = styled.a`
    a {
      &:hover {
        color: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        color: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  const HoverSpan = styled.span`
    span {
      &:hover {
        color: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        color: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  const HoverBg = styled.a`
    a {
      &:hover {
        color: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        color: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  return (
    <>
      {showData && (
        <footer
          style={{
            backgroundColor: siteConfig?.brandButtonPressedColor?.hex,
          }}
          className=" flex flex-col"
        >
          <section className="bg-themeDark py-10">
            <div className="container">
              <div className="grid md:grid-cols-5 gap-5 md:gap-10 items-center">
                <div className="col-span-2 lg:w-3/4">
                  <div className="flex w-full items-center">
                    <div className="contain-image flex items-center mr-8">
                      {siteConfig?.saveTheChildrenIcon && (
                        <ImageUI
                          src={siteConfig?.saveTheChildrenIcon?.webp}
                          alt={siteConfig?.saveTheChildrenIcon?.alt}
                          title={siteConfig?.saveTheChildrenIcon?.title}
                          width={250}
                          height={50}
                        />
                      )}
                    </div>
                    <div className="text-white w-full md:w-3/4">
                      <h4 className="h4-web font-bold mb-2">
                        {" "}
                        {saveTheChildrenTitle}
                      </h4>
                      <p
                        className="text-xs inline-block xl:w-2/3 hide-br leading-5"
                        dangerouslySetInnerHTML={{
                          __html: saveTheChildrenSubTitle?.replace(
                            /\n/g,
                            " <br/> "
                          ),
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
                <div className="col-span-3 border-t border-lightest pt-10 md:border-t-0 md:pt-0">
                  <div className="flex items-center flex-grow justify-center md:justify-start lg:justify-end">
                    {siteConfig?.footerIcons?.map((item, index) => {
                      return (
                        <div className="relative contain-image" key={index}>
                          <ImageUI
                            src={item?.webp}
                            alt={item?.alt}
                            title={item?.title}
                            width={107}
                            height={50}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-10 text-white">
            <div className="container">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
                <div className="col-span-1 lg:col-span-2">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
                    <div className="text-center md:text-left contain-image contain-image-left">
                      <Logo
                        imageSrc={siteConfig?.logoFooter?.webp}
                        imageAlt={siteConfig?.logoFooter?.alt}
                        imageTitle={siteConfig?.logoFooter?.title}
                        width={170}
                        height={90}
                      />
                    </div>
                    <div className="hidden md:flex">
                      <ul>
                        {siteConfig?.footerMenu?.map((item, index) => {
                          return (
                            <li key={index}>
                              <HoverLink>
                                <Link
                                  href={getHeaderMenuSlug(item)}
                                  as={getHeaderMenuSlug(item)}
                                  className="h6-web uppercase mb-2 block"
                                >
                                  {item?.title}
                                </Link>
                              </HoverLink>
                            </li>
                          );
                        })}
                        <li className="pt-[32px] mb-2 block h4-web capitalize">
                          <HoverLink>
                            <a
                              href={`privacy-policy`}
                              className=" no-brand  font-bold text-white hover:text-link"
                            >
                              {labelsList?.privacyPolicy}
                            </a>
                          </HoverLink>
                        </li>
                        <li className="mb-2 block h4-web capitalize">
                          <HoverSpan>
                            <span
                              id="csconsentlink"
                              className=" no-brand font-bold text-white  cursor-pointer"
                            >
                              {labelsList?.cookieSettings}
                            </span>
                          </HoverSpan>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-span-1 lg:col-span-3">
                  <div className="grid grid-cols-1 text-center md:text-left md:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-10">
                    <div className="col-span-1 lg:col-span-3">
                      <div className="w-full md:w-3/4">
                        <h4
                          className="h4-web mb-4"
                          dangerouslySetInnerHTML={{
                            __html: contactDetail?.replace(/\n/g, " <br/> "),
                          }}
                        ></h4>

                        <div className="md:hidden">
                          <div className="contact">
                            <HoverBg>
                              <p>
                                <a
                                  href={`tel:${phone?.replace("tel. ", "")}`}
                                  className="block menu-item hover:text-themeHover"
                                >
                                  {phone}
                                </a>
                                <a
                                  href="#!"
                                  className="block menu-item hover:text-themeHover"
                                >
                                  {fax}
                                </a>
                                <a
                                  href={`mailto:${email}`}
                                  className="menu-item hover:text-themeHover"
                                >
                                  {email}
                                </a>
                              </p>
                            </HoverBg>
                          </div>
                          <div className="mob-links my-10">
                            <ul>
                              {siteConfig?.footerMenu?.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <HoverLink>
                                      <Link
                                        href={getHeaderMenuSlug(item)}
                                        as={getHeaderMenuSlug(item)}
                                        className="font-extrabold tracking-wider uppercase mb-2 text-sm block hover:text-themeHover"
                                      >
                                        {item?.title}
                                      </Link>
                                    </HoverLink>
                                  </li>
                                );
                              })}
                              <li className="pt-[32px] mb-2 block h4-web capitalize">
                                <HoverLink>
                                  <a
                                    href={`privacy-policy`}
                                    className="no-brand font-bold text-white hover:text-link"
                                  >
                                    {labelsList?.privacyPolicy}
                                  </a>
                                </HoverLink>
                              </li>
                              <li className="mb-2 block h4-web capitalize">
                                <HoverSpan>
                                  <span
                                    id="csconsentlink"
                                    className="no-brand font-bold text-white  cursor-pointer"
                                  >
                                    {labelsList?.cookieSettings}
                                  </span>
                                </HoverSpan>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <h4
                          className="h4-web"
                          dangerouslySetInnerHTML={{
                            __html: siteConfig?.companyInfo?.replace(
                              /\n/g,
                              " <br/> "
                            ),
                          }}
                        ></h4>
                      </div>
                    </div>
                    <div className="col-span-1 hidden md:flex lg:col-span-2">
                      <ul>
                        <li className="flex mb-3 items-center justify-center md:justify-start">
                          <div className="icon">
                            <div className="w-5 mr-4">
                              <iconify-icon
                                icon="ion:call"
                                width="16"
                              ></iconify-icon>
                            </div>
                          </div>
                          <HoverBg>
                            <div className="content h4-web">
                              <a
                                href={`tel:${phone?.replace("tel. ", "")}`}
                                className="block menu-item hover:text-themeHover"
                              >
                                {phone}
                              </a>
                              <a
                                href="#!"
                                className="block menu-item hover:text-themeHover"
                              >
                                {fax}
                              </a>
                            </div>
                          </HoverBg>
                        </li>

                        <li className="flex mb-3 items-center justify-center md:justify-start">
                          <div className="icon">
                            <div className="w-5 mr-4">
                              <iconify-icon
                                icon="clarity:email-solid"
                                width="16"
                              ></iconify-icon>
                            </div>
                          </div>
                          <HoverBg>
                            <div className="content">
                              <a
                                href={`mailto:${email}`}
                                className="menu-item  h4-web hover:text-themeHover"
                              >
                                {email}
                              </a>
                            </div>
                          </HoverBg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Sticky footer for specific page */}

          {sediPageData && route?.indexOf("sedi") > -1 && (
            <div className="h-[65px] md:hidden">
              <div className="flex items-center fixed bottom-0 left-0 right-0 w-full h-[65px] bg-[#0584fc] z-10">
                <a
                  href={`tel:+${sediPageData?.phone}`}
                  className="text-white font-extrabold tracking-[2px] text-[14px] uppercase text-center h-full flex items-center justify-center w-[50%]"
                >
                  {labelsList?.callUs}
                </a>
                <a
                  href={`mailto:${sediPageData?.email}`}
                  className="text-theme border-4 bg-white tracking-[2px] text-[14px] font-extrabold uppercase text-center h-full flex items-center justify-center w-[50%]"
                >
                  {labelsList?.contactUs}
                </a>
              </div>
            </div>
          )}
        </footer>
      )}
      {isPreview && (
        <section
          className={`bg-[#1ba904a3] z-50 fixed font-Inter
          ${
            isPreviewOpen
              ? "py-[38px] md:py-4 px-6 bottom-0 w-full"
              : "w-[62px] right-[10px] rounded-lg bottom-[10px]"
          }`}
        >
          {isPreviewOpen && (
            <div
              className="absolute text-white top-3 right-3 cursor-pointer"
              onClick={() => setIsPreviewOpen(false)}
            >
              <iconify-icon
                icon="ep:close-bold"
                width="24"
                height="44"
              ></iconify-icon>
            </div>
          )}
          <div className="flex flex-col items-center justify-center gap-4 text-white md:flex-row">
            <div
              className={`flex items-center justify-center
              ${isPreviewOpen ? "" : "py-[13px] px-4"}
              `}
              onClick={() => setIsPreviewOpen(true)}
            >
              <iconify-icon
                className="iconify"
                icon="mdi:eye"
                width="30"
              ></iconify-icon>
            </div>
            {isPreviewOpen && (
              <div className="flex flex-col gap-6 md:flex-row items-center">
                <span className="text-sm font-bold leading-4 text-center md:text-left">
                  This website is currently viewed in preview mode and may not
                  reflect the content of the latest build
                </span>
                <Link
                  href="/api/exit-preview/"
                  className="btn rounded-[20px] py-[7px] px-6 font-bold text-sm leading-[17px] tracking-widest border-white w-max text-white hover:bg-[#ffffff1a]"
                >
                  EXIT PREVIEW MODE
                </Link>
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
}

export default Footer;
